import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/visual' // 默认跳转到可视化大屏
    },
    {
        path: '/visual',
        name: 'Home',
        component: () => import('../views/dashboard/Dashboard.vue'),
        meta: { title: '首页' },
        children: [
            {
                path: '/visual',
                name: 'Visual',
                component: () => import('../views/dashboard/visual/visual.vue'),
                meta: { title: '可视化大屏' }
            },
            {
                path: '/alarm',
                name: 'Alarm',
                component: () => import('../views/dashboard/alarm/alarm.vue'),
                meta: { title: '告警管理' }
            },
            {
                path: '/device',
                name: 'Device',
                component: () => import('../views/dashboard/device/device.vue'),
                meta: { title: '设备管理' }
            },
            {
                path: '/department',
                name: 'department',
                component: () => import('../views/dashboard/department/departmentManagement.vue'),
                meta: { title: '设备管理' }
            },
            {
                path: '/tenant',
                name: 'Tenant',
                component: () => import('../views/dashboard/tenant/tenant.vue'),
                meta: { title: '租户管理' }
            },
            {
                path: '/log',
                name: 'Log',
                component: () => import('../views/dashboard/log.vue'),
                meta: { title: '日志管理' }
            },
            {
                path: '/settings',
                name: 'Settings',
                component: () => import('../views/dashboard/settings/settings.vue'),
                meta: { title: '系统设置' }
            }
        ]
    },

    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login.vue'),
    },

    {
        path: '/demo',
        name: 'demo',
        component: () => import('../views/dashboard/visual/demo.vue'),
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router;